enum CPS_TYPES {
  FACT_SORTING = 'fact-sorting',
  HIDDEN_PROFILE = 'hidden-profile',
  NEGOTIATION = 'negotiation',
}

export default CPS_TYPES;
